<template>
  <div>
    <CommonTab>
      <div slot="main-menu" @click="$router.push('/')">商城首页</div>
      <ChannelTabMenu slot="other-menu">
        <CommonTabMenuItem>
          <div @click="goCate(121)">
            I型糖尿病
          </div>
        </CommonTabMenuItem>
        <CommonTabMenuItem>
          <div @click="goCate(122)">
            II型糖尿病
          </div>
        </CommonTabMenuItem>
      </ChannelTabMenu>
    </CommonTab>
    <div class="cate-list">
      <div class="cate">
        <div class="item">
          <div
            class="bg"
            :class="active === 1 ? 'active' : ''"
            @click="getDetail(1)"
          >
            I型
          </div>
          <div class="name">I型糖尿病</div>
        </div>
        <div class="item">
          <div
            class="bg"
            :class="active === 2 ? 'active' : ''"
            @click="getDetail(2)"
          >
            II型
          </div>
          <div class="name">II型糖尿病</div>
        </div>
        <div class="item">
          <div
            class="bg"
            :class="active === 3 ? 'active' : ''"
            @click="getDetail(3)"
          >
            并发症
          </div>
          <div class="name">糖尿病并发症</div>
        </div>
        <div class="item">
          <div
            class="bg"
            :class="active === 4 ? 'active' : ''"
            @click="getDetail(4)"
          >
            检测
          </div>
          <div class="name">自我检测</div>
        </div>
        <div class="item">
          <div
            class="bg"
            :class="active === 5 ? 'active' : ''"
            @click="getDetail(5)"
          >
            资讯
          </div>
          <div class="name">健康资讯</div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import CommonTab from "@/components/pc/nav/CommonTab";
import ChannelTabMenu from "@components/pc/nav/ChannelTabMenu";
import CommonTabMenuItem from "@components/pc/nav/CommonTabMenuItem";
export default {
  name: "DiabetesCate",
  components: {
    CommonTab,
    ChannelTabMenu,
    CommonTabMenuItem
  },
  data() {
    return {
      active: 1
    };
  },
  created() {
    this.active = parseInt(this.$route.query.cate);
  },
  methods: {
    goCate(id) {
      this.$router.push({
        name: "GoodsList",
        params: {
          mainId: 9,
          secondId: id
        }
      });
    },
    getDetail(id) {
      this.active = id;
      if (id === 1) {
        this.$router.push({
          path: "/diabetesCate"
        });
      } else if (id === 2) {
        this.$router.push({
          path: "/diabetesCate/II"
        });
      } else if (id === 3) {
        this.$router.push({
          path: "/diabetesCate/Three"
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.cate-list
  width 100%
  background #fff
  padding-top 50px
  .cate
    width 900px
    margin 0 auto
    display flex
    justify-content space-between
    .item
      width 25%
      .bg
        width 70px
        height 70px
        line-height 70px
        margin 0 auto
        text-align center
        background #dfcc65
        border-radius 50%
        margin-bottom 20px
        color #fff
        font-size 16px
        cursor pointer
        &.active
          transform scale(1.5)
      .name
        color #dfcc65
        text-align center
        font-size 16px

      &:nth-child(2)
        .bg
          background #7ad26e
        .name
          color #7ad26e
      &:nth-child(3)
        .bg
          background #fd8257
        .name
          color #fd8257
      &:nth-child(4)
        .bg
          background #6987cd
        .name
          color #6987cd
      &:nth-child(5)
        .bg
          background #5ca3b9
        .name
          color #5ca3b9
</style>
